// export const API_AMOR = "http://localhost:8000/v1/main";
export const API_AMOR =
  "https://amor.production.pangkalpinangkota.go.id/v1/main";
export const API_PORTAL = "https://portal.production.pangkalpinangkota.go.id";
